import * as authentication from "../../common/actions/authentication";
import * as getorders from "../actions/dominosActions.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        creating: false,
        loading: false,
        customers : {
            untreatedCustomers : [],
            treatedCustomers : [],
        },
    });
};

/**
 * Dominos reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch (action.type) {
    case getorders.SET_DOMINOS_ORDERS:
        return state.merge({
            customers: action.payload,
        });
    case getorders.SET_NO_OF_DOLLIES:
    {
        // Try to find the customer    
        var index = state.customers.untreatedCustomers.findIndex( (c) => c.salesOrderId===action.salesOrderId);

        if(index !== -1)
        {
            return Immutable.setIn(state, ["customers","untreatedCustomers", index], action.customer);
        } 
        else    
        {
            index = state.customers.treatedCustomers.findIndex( (c) => c.salesOrderId===action.salesOrderId);
            return Immutable.setIn(state, ["customers","treatedCustomers", index], action.customer);
        }
       
    }
    case getorders.SELECT_CUSTOMER:
    {
        // Try to find the customer    
        var indexCus = state.customers.untreatedCustomers.findIndex( (c) => c.salesOrderId===action.salesOrderId);

        if(indexCus !== -1)
        {
            return Immutable.setIn(state, ["customers","untreatedCustomers", indexCus], action.customer);
        } 
        else    
        {
            indexCus = state.customers.treatedCustomers.findIndex( (c) => c.salesOrderId===action.salesOrderId);
            return Immutable.setIn(state, ["customers","treatedCustomers", indexCus], action.customer);
        }
       
    }
    case getorders.CREATE_LABELS:
        return Immutable.setIn(state, ["creating"], action.creating);
    case getorders.LOADING:
        return Immutable.setIn(state, ["loading"], action.loading);
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}
